import { TFunction } from "react-i18next";

export const itemTypeScheduling = ({ t }: { t: TFunction<'translation', undefined> }) => [
    {
        label: t('schedule.assigned.programmed'),
        value: false
    },
    {
        label: t('schedule.assigned.free'),
        value: true
    }
]